/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Save_ButtonInputs */

const en_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const fr_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const ru_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранять`)
};

const es_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorrar`)
};

const zh_cn2_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省`)
};

const ja_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const hi_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाना`)
};

const pt_pt2_image_export_style_save_button = /** @type {(inputs: Image_Export_Style_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Image_Export_Style_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_save_button = /** @type {((inputs?: Image_Export_Style_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_save_button(inputs)
	if (locale === "de") return de_image_export_style_save_button(inputs)
	if (locale === "it") return it_image_export_style_save_button(inputs)
	if (locale === "ru") return ru_image_export_style_save_button(inputs)
	if (locale === "es") return es_image_export_style_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_save_button(inputs)
	if (locale === "ja") return ja_image_export_style_save_button(inputs)
	if (locale === "hi") return hi_image_export_style_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_save_button(inputs)
	return en_image_export_style_save_button(inputs)
});